import React, { useEffect, useMemo } from 'react';
import { Approval } from '../../../../state/ducks/common/types';
import { ApprovalStage, WorkflowStatusDetails } from '../../../administration/general.settings/types';
import { FB, FBDialog, FBDialogState, FBProvider } from '../../../form.builder';
import useStyles from './approvalWorkflow.styles';
import WorkflowStage from './WorkflowStage';

export interface ApprovalWorkflowProps {
  changeRequestId?: string
  documentRevisionId?: string
  workflowStages: ApprovalStage[]
  workflowStatusDetails: WorkflowStatusDetails
  approvals: Approval[] | undefined
  isArtifactInReview?: boolean
  currentEmpId: string
  ownerId?: string
  artifactHasMappedFields?: boolean
  disabled?: boolean
  onApproveClick?: (approvalId: string) => void
  onRejectClick?: (approvalId: string) => void
}

const ApprovalWorkflow: React.FC<ApprovalWorkflowProps> = ({
  changeRequestId,
  documentRevisionId,
  workflowStages,
  workflowStatusDetails,
  approvals,
  isArtifactInReview,
  currentEmpId,
  ownerId,
  artifactHasMappedFields,
  disabled,
  onApproveClick,
  onRejectClick,
}) => {
  const classes = useStyles();
  const dialogState = FB.useRef(FBDialogState);

  const activeStageNumber = workflowStatusDetails?.currentStageInProgress ?? 1;
  const isOwner = currentEmpId === ownerId;

  const [expandedStages, setExpandedStages] = React.useState(() => new Set<number>([activeStageNumber]));

  const toggleStage = (stageNumber: number) => {
    setExpandedStages(prev => {
      const next = new Set(prev);

      if (next.has(stageNumber)) {
        next.delete(stageNumber);
      } else {
        next.add(stageNumber);
      }

      return next;
    });
  };

  useEffect(() => {
    setExpandedStages(prev => {
      const next = new Set(prev);
      next.add(activeStageNumber);

      return next;
    });
  }, [activeStageNumber]);

  const sortedStages = useMemo(() =>
    [...workflowStages].sort((a, b) => a.stageNumber - b.stageNumber),
  [workflowStages]);

  return (
    <div className={classes.workflow}>
      {sortedStages.map(stage => {
        return (
          <FBProvider {...{ dialogState }}>
            <FBDialog />
            <WorkflowStage
              key={stage.stageNumber}
              changeRequestId={changeRequestId}
              documentRevisionId={documentRevisionId}
              stage={stage}
              currentEmpId={currentEmpId}
              isOwner={isOwner}
              approvals={approvals}
              workflowStatusDetails={workflowStatusDetails}
              expandedStages={expandedStages}
              toggleStage={toggleStage}
              onApproveClick={onApproveClick}
              onRejectClick={onRejectClick}
              isArtifactInReview={isArtifactInReview}
              artifactHasMappedFields={artifactHasMappedFields}
              disabled={disabled}
            />
          </FBProvider>
        );
      })}

    </div>

  );
};

export default ApprovalWorkflow;
